interface ErrorMessageProps {
  message?: string | string[] | null;
  children?: React.ReactNode;
}

const ErrorMessage = ({ message, children }: ErrorMessageProps) => {
  if (!message && !children) return null;
  if (!message || (Array.isArray(message) && message.length === 0 && !children)) return null;
  return (
    <div>
      <span className="w-100 block text-xs italic text-red-500">{message}</span>
      {children}
    </div>
  );
};

export default ErrorMessage;
